export const FIFA_GROUP_MATCHES = {
  groupA: [{
    id: 'drzunOfo',
    date: '2022-11-29T15:00:00.000Z',
    localTeam: {
      id: '8tbm8Tri',
      name: 'Эквадор',
      score: 1,
      countryCode: 'EC',
      flagUrl: 'https://cdn.nur.kz/static/football/EC.png'
    },
    visitorTeam: {
      id: 'hOIsJLJr',
      name: 'Сенегал',
      score: 2,
      countryCode: 'SN',
      flagUrl: 'https://cdn.nur.kz/static/football/SN.png'
    }
  }, {
    id: 'fZmDj4nU',
    date: '2022-11-29T15:00:00.000Z',
    localTeam: {
      id: 'WYintcWb',
      name: 'Нидерланды',
      score: 2,
      countryCode: 'NL',
      flagUrl: 'https://cdn.nur.kz/static/football/NL.png'
    },
    visitorTeam: {
      id: 'zqzHL77i',
      name: 'Катар',
      score: 0,
      countryCode: 'QA',
      flagUrl: 'https://cdn.nur.kz/static/football/QA.png'
    }
  }, {
    id: 'Qaq9ipXN',
    date: '2022-11-25T16:00:00.000Z',
    localTeam: {
      id: 'WYintcWb',
      name: 'Нидерланды',
      score: 1,
      countryCode: 'NL',
      flagUrl: 'https://cdn.nur.kz/static/football/NL.png'
    },
    visitorTeam: {
      id: '8tbm8Tri',
      name: 'Эквадор',
      score: 1,
      countryCode: 'EC',
      flagUrl: 'https://cdn.nur.kz/static/football/EC.png'
    }
  }, {
    id: 'n9p5hQHH',
    date: '2022-11-25T13:00:00.000Z',
    localTeam: {
      id: 'zqzHL77i',
      name: 'Катар',
      score: 1,
      countryCode: 'QA',
      flagUrl: 'https://cdn.nur.kz/static/football/QA.png'
    },
    visitorTeam: {
      id: 'hOIsJLJr',
      name: 'Сенегал',
      score: 3,
      countryCode: 'SN',
      flagUrl: 'https://cdn.nur.kz/static/football/SN.png'
    }
  }, {
    id: '4pe0g62B',
    date: '2022-11-21T16:00:00.000Z',
    localTeam: {
      id: 'hOIsJLJr',
      name: 'Сенегал',
      score: 0,
      countryCode: 'SN',
      flagUrl: 'https://cdn.nur.kz/static/football/SN.png'
    },
    visitorTeam: {
      id: 'WYintcWb',
      name: 'Нидерланды',
      score: 2,
      countryCode: 'NL',
      flagUrl: 'https://cdn.nur.kz/static/football/NL.png'
    }
  }, {
    id: 'jsidfnm5',
    date: '2022-11-20T16:00:00.000Z',
    localTeam: {
      id: 'zqzHL77i',
      name: 'Катар',
      score: 0,
      countryCode: 'QA',
      flagUrl: 'https://cdn.nur.kz/static/football/QA.png'
    },
    visitorTeam: {
      id: '8tbm8Tri',
      name: 'Эквадор',
      score: 2,
      countryCode: 'EC',
      flagUrl: 'https://cdn.nur.kz/static/football/EC.png'
    }
  }],
  groupB: [{
    id: 'rytnS5cE',
    date: '2022-11-29T19:00:00.000Z',
    localTeam: {
      id: 'YcUP0Nqp',
      name: 'Уэльс',
      score: 0,
      countryCode: 'WS',
      flagUrl: 'https://cdn.nur.kz/static/football/WS.png'
    },
    visitorTeam: {
      id: 'j9N9ZNFA',
      name: 'Англия',
      score: 3,
      countryCode: 'GB',
      flagUrl: 'https://cdn.nur.kz/static/football/GB.png'
    }
  }, {
    id: '6D3ThfTc',
    date: '2022-11-29T19:00:00.000Z',
    localTeam: {
      id: 'xrRx85iA',
      name: 'Иран',
      score: 0,
      countryCode: 'IR',
      flagUrl: 'https://cdn.nur.kz/static/football/IR.png'
    },
    visitorTeam: {
      id: 'fuitL4CF',
      name: 'США',
      score: 1,
      countryCode: 'US',
      flagUrl: 'https://cdn.nur.kz/static/football/US.png'
    }
  }, {
    id: 'Cj4PgzEi',
    date: '2022-11-25T19:00:00.000Z',
    localTeam: {
      id: 'j9N9ZNFA',
      name: 'Англия',
      score: 0,
      countryCode: 'GB',
      flagUrl: 'https://cdn.nur.kz/static/football/GB.png'
    },
    visitorTeam: {
      id: 'fuitL4CF',
      name: 'США',
      score: 0,
      countryCode: 'US',
      flagUrl: 'https://cdn.nur.kz/static/football/US.png'
    }
  }, {
    id: '4psrTor8',
    date: '2022-11-25T10:00:00.000Z',
    localTeam: {
      id: 'YcUP0Nqp',
      name: 'Уэльс',
      score: 0,
      countryCode: 'WS',
      flagUrl: 'https://cdn.nur.kz/static/football/WS.png'
    },
    visitorTeam: {
      id: 'xrRx85iA',
      name: 'Иран',
      score: 2,
      countryCode: 'IR',
      flagUrl: 'https://cdn.nur.kz/static/football/IR.png'
    }
  }, {
    id: 'GUm04257',
    date: '2022-11-21T19:00:00.000Z',
    localTeam: {
      id: 'fuitL4CF',
      name: 'США',
      score: 1,
      countryCode: 'US',
      flagUrl: 'https://cdn.nur.kz/static/football/US.png'
    },
    visitorTeam: {
      id: 'YcUP0Nqp',
      name: 'Уэльс',
      score: 1,
      countryCode: 'WS',
      flagUrl: 'https://cdn.nur.kz/static/football/WS.png'
    }
  }, {
    id: '0G0LfGbo',
    date: '2022-11-21T13:00:00.000Z',
    localTeam: {
      id: 'j9N9ZNFA',
      name: 'Англия',
      score: 6,
      countryCode: 'GB',
      flagUrl: 'https://cdn.nur.kz/static/football/GB.png'
    },
    visitorTeam: {
      id: 'xrRx85iA',
      name: 'Иран',
      score: 2,
      countryCode: 'IR',
      flagUrl: 'https://cdn.nur.kz/static/football/IR.png'
    }
  }],
  groupC: [{
    id: 'UgDIW3Ce',
    date: '2022-11-30T19:00:00.000Z',
    localTeam: {
      id: 'biSY8ox4',
      name: 'С.Аравия',
      score: 1,
      countryCode: 'SA',
      flagUrl: 'https://cdn.nur.kz/static/football/SA.png'
    },
    visitorTeam: {
      id: 'O6iHcNkd',
      name: 'Мексика',
      score: 2,
      countryCode: 'MX',
      flagUrl: 'https://cdn.nur.kz/static/football/MX.png'
    }
  }, {
    id: 'nVNDXqck',
    date: '2022-11-30T19:00:00.000Z',
    localTeam: {
      id: '2HzmcynI',
      name: 'Польша',
      score: 0,
      countryCode: 'PL',
      flagUrl: 'https://cdn.nur.kz/static/football/PL.png'
    },
    visitorTeam: {
      id: 'f9OppQjp',
      name: 'Аргентина',
      score: 2,
      countryCode: 'AR',
      flagUrl: 'https://cdn.nur.kz/static/football/AR.png'
    }
  }, {
    id: 'tWetjhDG',
    date: '2022-11-26T19:00:00.000Z',
    localTeam: {
      id: 'f9OppQjp',
      name: 'Аргентина',
      score: 2,
      countryCode: 'AR',
      flagUrl: 'https://cdn.nur.kz/static/football/AR.png'
    },
    visitorTeam: {
      id: 'O6iHcNkd',
      name: 'Мексика',
      score: 0,
      countryCode: 'MX',
      flagUrl: 'https://cdn.nur.kz/static/football/MX.png'
    }
  }, {
    id: 'YRJ9YPsq',
    date: '2022-11-26T13:00:00.000Z',
    localTeam: {
      id: '2HzmcynI',
      name: 'Польша',
      score: 2,
      countryCode: 'PL',
      flagUrl: 'https://cdn.nur.kz/static/football/PL.png'
    },
    visitorTeam: {
      id: 'biSY8ox4',
      name: 'С.Аравия',
      score: 0,
      countryCode: 'SA',
      flagUrl: 'https://cdn.nur.kz/static/football/SA.png'
    }
  }, {
    id: '2ucxiYcA',
    date: '2022-11-22T16:00:00.000Z',
    localTeam: {
      id: 'O6iHcNkd',
      name: 'Мексика',
      score: 0,
      countryCode: 'MX',
      flagUrl: 'https://cdn.nur.kz/static/football/MX.png'
    },
    visitorTeam: {
      id: '2HzmcynI',
      name: 'Польша',
      score: 0,
      countryCode: 'PL',
      flagUrl: 'https://cdn.nur.kz/static/football/PL.png'
    }
  }, {
    id: 'p42XiEr4',
    date: '2022-11-22T10:00:00.000Z',
    localTeam: {
      id: 'f9OppQjp',
      name: 'Аргентина',
      score: 1,
      countryCode: 'AR',
      flagUrl: 'https://cdn.nur.kz/static/football/AR.png'
    },
    visitorTeam: {
      id: 'biSY8ox4',
      name: 'С.Аравия',
      score: 2,
      countryCode: 'SA',
      flagUrl: 'https://cdn.nur.kz/static/football/SA.png'
    }
  }],
  groupD: [{
    id: 'xMN9a6FL',
    date: '2022-11-30T15:00:00.000Z',
    localTeam: {
      id: 'xSrf6qMM',
      name: 'Австралия',
      score: 1,
      countryCode: 'AU',
      flagUrl: 'https://cdn.nur.kz/static/football/AU.png'
    },
    visitorTeam: {
      id: '0KUdxQVi',
      name: 'Дания',
      score: 0,
      countryCode: 'DK',
      flagUrl: 'https://cdn.nur.kz/static/football/DK.png'
    }
  }, {
    id: '0hE7gRJ8',
    date: '2022-11-30T15:00:00.000Z',
    localTeam: {
      id: 'QqZVYk95',
      name: 'Тунис',
      score: 1,
      countryCode: 'TN',
      flagUrl: 'https://cdn.nur.kz/static/football/TN.png'
    },
    visitorTeam: {
      id: 'QkGeVG1n',
      name: 'Франция',
      score: 0,
      countryCode: 'FR',
      flagUrl: 'https://cdn.nur.kz/static/football/FR.png'
    }
  }, {
    id: 'M1F3f742',
    date: '2022-11-26T16:00:00.000Z',
    localTeam: {
      id: 'QkGeVG1n',
      name: 'Франция',
      score: 2,
      countryCode: 'FR',
      flagUrl: 'https://cdn.nur.kz/static/football/FR.png'
    },
    visitorTeam: {
      id: '0KUdxQVi',
      name: 'Дания',
      score: 1,
      countryCode: 'DK',
      flagUrl: 'https://cdn.nur.kz/static/football/DK.png'
    }
  }, {
    id: 'bVO50n0F',
    date: '2022-11-26T10:00:00.000Z',
    localTeam: {
      id: 'QqZVYk95',
      name: 'Тунис',
      score: 0,
      countryCode: 'TN',
      flagUrl: 'https://cdn.nur.kz/static/football/TN.png'
    },
    visitorTeam: {
      id: 'xSrf6qMM',
      name: 'Австралия',
      score: 1,
      countryCode: 'AU',
      flagUrl: 'https://cdn.nur.kz/static/football/AU.png'
    }
  }, {
    id: 'IJ781Sp9',
    date: '2022-11-22T19:00:00.000Z',
    localTeam: {
      id: 'QkGeVG1n',
      name: 'Франция',
      score: 4,
      countryCode: 'FR',
      flagUrl: 'https://cdn.nur.kz/static/football/FR.png'
    },
    visitorTeam: {
      id: 'xSrf6qMM',
      name: 'Австралия',
      score: 1,
      countryCode: 'AU',
      flagUrl: 'https://cdn.nur.kz/static/football/AU.png'
    }
  }, {
    id: '8pCMVNR1',
    date: '2022-11-22T13:00:00.000Z',
    localTeam: {
      id: '0KUdxQVi',
      name: 'Дания',
      score: 0,
      countryCode: 'DK',
      flagUrl: 'https://cdn.nur.kz/static/football/DK.png'
    },
    visitorTeam: {
      id: 'QqZVYk95',
      name: 'Тунис',
      score: 0,
      countryCode: 'TN',
      flagUrl: 'https://cdn.nur.kz/static/football/TN.png'
    }
  }],
  groupE: [{
    id: 'I5Sd8Axs',
    date: '2022-12-01T19:00:00.000Z',
    localTeam: {
      id: 'C4ePE2kq',
      name: 'Коста-Рика',
      score: 2,
      countryCode: 'CR',
      flagUrl: 'https://cdn.nur.kz/static/football/CR.png'
    },
    visitorTeam: {
      id: 'ptQide1O',
      name: 'Германия',
      score: 4,
      countryCode: 'DE',
      flagUrl: 'https://cdn.nur.kz/static/football/DE.png'
    }
  }, {
    id: 'js7KjP3R',
    date: '2022-12-01T19:00:00.000Z',
    localTeam: {
      id: 'ULXPdOUj',
      name: 'Япония',
      score: 2,
      countryCode: 'JP',
      flagUrl: 'https://cdn.nur.kz/static/football/JP.png'
    },
    visitorTeam: {
      id: 'bLyo6mco',
      name: 'Испания',
      score: 1,
      countryCode: 'ES',
      flagUrl: 'https://cdn.nur.kz/static/football/ES.png'
    }
  }, {
    id: 'dK7Gi5lL',
    date: '2022-11-27T19:00:00.000Z',
    localTeam: {
      id: 'bLyo6mco',
      name: 'Испания',
      score: 1,
      countryCode: 'ES',
      flagUrl: 'https://cdn.nur.kz/static/football/ES.png'
    },
    visitorTeam: {
      id: 'ptQide1O',
      name: 'Германия',
      score: 1,
      countryCode: 'DE',
      flagUrl: 'https://cdn.nur.kz/static/football/DE.png'
    }
  }, {
    id: 'COkUCjUP',
    date: '2022-11-27T10:00:00.000Z',
    localTeam: {
      id: 'ULXPdOUj',
      name: 'Япония',
      score: 0,
      countryCode: 'JP',
      flagUrl: 'https://cdn.nur.kz/static/football/JP.png'
    },
    visitorTeam: {
      id: 'C4ePE2kq',
      name: 'Коста-Рика',
      score: 1,
      countryCode: 'CR',
      flagUrl: 'https://cdn.nur.kz/static/football/CR.png'
    }
  }, {
    id: 'YXjQDWEJ',
    date: '2022-11-23T16:00:00.000Z',
    localTeam: {
      id: 'bLyo6mco',
      name: 'Испания',
      score: 7,
      countryCode: 'ES',
      flagUrl: 'https://cdn.nur.kz/static/football/ES.png'
    },
    visitorTeam: {
      id: 'C4ePE2kq',
      name: 'Коста-Рика',
      score: 0,
      countryCode: 'CR',
      flagUrl: 'https://cdn.nur.kz/static/football/CR.png'
    }
  }, {
    id: 'rH3ChoZE',
    date: '2022-11-23T13:00:00.000Z',
    localTeam: {
      id: 'ptQide1O',
      name: 'Германия',
      score: 1,
      countryCode: 'DE',
      flagUrl: 'https://cdn.nur.kz/static/football/DE.png'
    },
    visitorTeam: {
      id: 'ULXPdOUj',
      name: 'Япония',
      score: 2,
      countryCode: 'JP',
      flagUrl: 'https://cdn.nur.kz/static/football/JP.png'
    }
  }],
  groupF: [{
    id: 'dKTo7pl8',
    date: '2022-12-01T15:00:00.000Z',
    localTeam: {
      id: 'x4toKORL',
      name: 'Канада',
      score: 1,
      countryCode: 'CA',
      flagUrl: 'https://cdn.nur.kz/static/football/CA.png'
    },
    visitorTeam: {
      id: 'IDKYO3R8',
      name: 'Марокко',
      score: 2,
      countryCode: 'MA',
      flagUrl: 'https://cdn.nur.kz/static/football/MA.png'
    }
  }, {
    id: 'fFk3r1B7',
    date: '2022-12-01T15:00:00.000Z',
    localTeam: {
      id: 'K8aznggo',
      name: 'Хорватия',
      score: 0,
      countryCode: 'HR',
      flagUrl: 'https://cdn.nur.kz/static/football/HR.png'
    },
    visitorTeam: {
      id: 'GbB957na',
      name: 'Бельгия',
      score: 0,
      countryCode: 'BE',
      flagUrl: 'https://cdn.nur.kz/static/football/BE.png'
    }
  }, {
    id: 'runaqsd1',
    date: '2022-11-27T16:00:00.000Z',
    localTeam: {
      id: 'K8aznggo',
      name: 'Хорватия',
      score: 4,
      countryCode: 'HR',
      flagUrl: 'https://cdn.nur.kz/static/football/HR.png'
    },
    visitorTeam: {
      id: 'x4toKORL',
      name: 'Канада',
      score: 1,
      countryCode: 'CA',
      flagUrl: 'https://cdn.nur.kz/static/football/CA.png'
    }
  }, {
    id: 'lInepNte',
    date: '2022-11-27T13:00:00.000Z',
    localTeam: {
      id: 'GbB957na',
      name: 'Бельгия',
      score: 0,
      countryCode: 'BE',
      flagUrl: 'https://cdn.nur.kz/static/football/BE.png'
    },
    visitorTeam: {
      id: 'IDKYO3R8',
      name: 'Марокко',
      score: 2,
      countryCode: 'MA',
      flagUrl: 'https://cdn.nur.kz/static/football/MA.png'
    }
  }, {
    id: 'hjgnnqCr',
    date: '2022-11-23T19:00:00.000Z',
    localTeam: {
      id: 'GbB957na',
      name: 'Бельгия',
      score: 1,
      countryCode: 'BE',
      flagUrl: 'https://cdn.nur.kz/static/football/BE.png'
    },
    visitorTeam: {
      id: 'x4toKORL',
      name: 'Канада',
      score: 0,
      countryCode: 'CA',
      flagUrl: 'https://cdn.nur.kz/static/football/CA.png'
    }
  }, {
    id: 'ARmio3Rl',
    date: '2022-11-23T10:00:00.000Z',
    localTeam: {
      id: 'IDKYO3R8',
      name: 'Марокко',
      score: 0,
      countryCode: 'MA',
      flagUrl: 'https://cdn.nur.kz/static/football/MA.png'
    },
    visitorTeam: {
      id: 'K8aznggo',
      name: 'Хорватия',
      score: 0,
      countryCode: 'HR',
      flagUrl: 'https://cdn.nur.kz/static/football/HR.png'
    }
  }],
  groupG: [{
    id: 'drCYctBf',
    date: '2022-12-02T19:00:00.000Z',
    localTeam: {
      id: '8Kl6iq0i',
      name: 'Сербия',
      score: 2,
      countryCode: 'RS',
      flagUrl: 'https://cdn.nur.kz/static/football/RS.png'
    },
    visitorTeam: {
      id: 'rHJ2vy1B',
      name: 'Швейцария',
      score: 3,
      countryCode: 'CH',
      flagUrl: 'https://cdn.nur.kz/static/football/CH.png'
    }
  }, {
    id: '2LCUbMel',
    date: '2022-12-02T19:00:00.000Z',
    localTeam: {
      id: 'zk1uVG2D',
      name: 'Камерун',
      score: 1,
      countryCode: 'CM',
      flagUrl: 'https://cdn.nur.kz/static/football/CM.png'
    },
    visitorTeam: {
      id: 'I9l9aqLq',
      name: 'Бразилия',
      score: 0,
      countryCode: 'BR',
      flagUrl: 'https://cdn.nur.kz/static/football/BR.png'
    }
  }, {
    id: 'ryWc4rYQ',
    date: '2022-11-28T16:00:00.000Z',
    localTeam: {
      id: 'I9l9aqLq',
      name: 'Бразилия',
      score: 1,
      countryCode: 'BR',
      flagUrl: 'https://cdn.nur.kz/static/football/BR.png'
    },
    visitorTeam: {
      id: 'rHJ2vy1B',
      name: 'Швейцария',
      score: 0,
      countryCode: 'CH',
      flagUrl: 'https://cdn.nur.kz/static/football/CH.png'
    }
  }, {
    id: 'lI8Qa2tr',
    date: '2022-11-28T10:00:00.000Z',
    localTeam: {
      id: 'zk1uVG2D',
      name: 'Камерун',
      score: 3,
      countryCode: 'CM',
      flagUrl: 'https://cdn.nur.kz/static/football/CM.png'
    },
    visitorTeam: {
      id: '8Kl6iq0i',
      name: 'Сербия',
      score: 3,
      countryCode: 'RS',
      flagUrl: 'https://cdn.nur.kz/static/football/RS.png'
    }
  }, {
    id: 'zBSk643E',
    date: '2022-11-24T19:00:00.000Z',
    localTeam: {
      id: 'I9l9aqLq',
      name: 'Бразилия',
      score: 2,
      countryCode: 'BR',
      flagUrl: 'https://cdn.nur.kz/static/football/BR.png'
    },
    visitorTeam: {
      id: '8Kl6iq0i',
      name: 'Сербия',
      score: 0,
      countryCode: 'RS',
      flagUrl: 'https://cdn.nur.kz/static/football/RS.png'
    }
  }, {
    id: '4pXg5OIK',
    date: '2022-11-24T10:00:00.000Z',
    localTeam: {
      id: 'rHJ2vy1B',
      name: 'Швейцария',
      score: 1,
      countryCode: 'CH',
      flagUrl: 'https://cdn.nur.kz/static/football/CH.png'
    },
    visitorTeam: {
      id: 'zk1uVG2D',
      name: 'Камерун',
      score: 0,
      countryCode: 'CM',
      flagUrl: 'https://cdn.nur.kz/static/football/CM.png'
    }
  }],
  groupH: [{
    id: '468UH12Q',
    date: '2022-12-02T15:00:00.000Z',
    localTeam: {
      id: 'nNBjHale',
      name: 'Гана',
      score: 0,
      countryCode: 'GH',
      flagUrl: 'https://cdn.nur.kz/static/football/GH.png'
    },
    visitorTeam: {
      id: 'xMk44orG',
      name: 'Уругвай',
      score: 2,
      countryCode: 'UY',
      flagUrl: 'https://cdn.nur.kz/static/football/UY.png'
    }
  }, {
    id: 'MsJPIsmK',
    date: '2022-12-02T15:00:00.000Z',
    localTeam: {
      id: 'K6Gs7P6G',
      name: 'Южная Корея',
      score: 2,
      countryCode: 'KR',
      flagUrl: 'https://cdn.nur.kz/static/football/KR.png'
    },
    visitorTeam: {
      id: 'WvJrjFVN',
      name: 'Португалия',
      score: 1,
      countryCode: 'PT',
      flagUrl: 'https://cdn.nur.kz/static/football/PT.png'
    }
  }, {
    id: 'fyRweveD',
    date: '2022-11-28T19:00:00.000Z',
    localTeam: {
      id: 'WvJrjFVN',
      name: 'Португалия',
      score: 2,
      countryCode: 'PT',
      flagUrl: 'https://cdn.nur.kz/static/football/PT.png'
    },
    visitorTeam: {
      id: 'xMk44orG',
      name: 'Уругвай',
      score: 0,
      countryCode: 'UY',
      flagUrl: 'https://cdn.nur.kz/static/football/UY.png'
    }
  }, {
    id: '8vFLJNXD',
    date: '2022-11-28T13:00:00.000Z',
    localTeam: {
      id: 'K6Gs7P6G',
      name: 'Южная Корея',
      score: 2,
      countryCode: 'KR',
      flagUrl: 'https://cdn.nur.kz/static/football/KR.png'
    },
    visitorTeam: {
      id: 'nNBjHale',
      name: 'Гана',
      score: 3,
      countryCode: 'GH',
      flagUrl: 'https://cdn.nur.kz/static/football/GH.png'
    }
  }, {
    id: 'zZAxc0Q0',
    date: '2022-11-24T16:00:00.000Z',
    localTeam: {
      id: 'WvJrjFVN',
      name: 'Португалия',
      score: 3,
      countryCode: 'PT',
      flagUrl: 'https://cdn.nur.kz/static/football/PT.png'
    },
    visitorTeam: {
      id: 'nNBjHale',
      name: 'Гана',
      score: 2,
      countryCode: 'GH',
      flagUrl: 'https://cdn.nur.kz/static/football/GH.png'
    }
  }, {
    id: 'GpSZeKu7',
    date: '2022-11-24T13:00:00.000Z',
    localTeam: {
      id: 'xMk44orG',
      name: 'Уругвай',
      score: 0,
      countryCode: 'UY',
      flagUrl: 'https://cdn.nur.kz/static/football/UY.png'
    },
    visitorTeam: {
      id: 'K6Gs7P6G',
      name: 'Южная Корея',
      score: 0,
      countryCode: 'KR',
      flagUrl: 'https://cdn.nur.kz/static/football/KR.png'
    }
  }]
};
